import { http } from "./interceptors";

export const REQUEST_METHODS = {
  GET: "GET",
  POST: "POST",
  PATCH: "PATCH",
  PUT: "PUT",
  DELETE: "DELETE"
};

export const request = async (method, url, data, headers) => {
  const response = await http({
    method,
    headers,
    url,
    data
  });
  return response.data;
};

export const requestForDownload = async (method, url, data, headers) => {
  const response = await http({
    method,
    headers,
    url,
    data
  });
  return response;
};

export const getForDownload = async (url, headers) => {
  return requestForDownload(REQUEST_METHODS.GET, url, null, headers);
};

export const get = async (url, headers) => {
  return request(REQUEST_METHODS.GET, url, null, headers);
};

export const post = async (url, data, headers) => {
  return request(REQUEST_METHODS.POST, url, data, headers);
};

export const put = async (url, data, headers) => {
  return request(REQUEST_METHODS.PUT, url, data, headers);
};

export const patch = async (url, data, headers) => {
  return request(REQUEST_METHODS.PATCH, url, data, headers);
};

export const remove = async (url, data, headers) => {
  return request(REQUEST_METHODS.DELETE, url, data, headers);
};
